"use client";

import { useEffect, useState } from "react";

function _urlBase64ToUint8Array(base64String: string) {
	const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
}

export function ServiceWorkerRegister() {
	const [_isSupported, setIsSupported] = useState(false);

	useEffect(() => {
		async function unregisterInDevelopment() {
			try {
				const registrations = await navigator.serviceWorker.getRegistrations();
				await Promise.all(
					registrations.map((registration) => registration.unregister()),
				);
				const keys = await caches.keys();
				await Promise.all(keys.map((key) => caches.delete(key)));
				console.log(
					"Service Worker disabled in development and caches cleared.",
				);
			} catch (error) {
				console.warn(
					"Failed to clear development service worker state:",
					error,
				);
			}
		}

		async function registerServiceWorker() {
			try {
				const registration = await navigator.serviceWorker.register("/sw.js", {
					scope: "/",
					updateViaCache: "none",
				});
				console.log(
					"Service Worker registered with scope:",
					registration.scope,
				);
			} catch (error) {
				console.error("Service Worker registration failed:", error);
			}
		}

		if ("serviceWorker" in navigator && "PushManager" in window) {
			setIsSupported(true);
			if (process.env.NODE_ENV !== "production") {
				unregisterInDevelopment();
				return;
			}
			registerServiceWorker();
		}
	}, []);

	return null; // This component doesn't render anything visible
}
